import { createContext, useContext, useState } from 'react';

const TalkingPointUpsertContext = createContext();

const initialState = {
  isOpenImagePreview: false,
  selectedImagePreview: [],
  isOpenModalSelectProduct: false,
  imagePreviewPreviousModal: null,
};

const initialFilterState = {
  search: '',
  limit: 10,
  page: 1,
};

const TalkingPointUpsertProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));

  return <TalkingPointUpsertContext.Provider value={{ updateState, state, updateFilterState, filterState }}>{children}</TalkingPointUpsertContext.Provider>;
};

export const useTalkingPointUpsertState = () => {
  return useContext(TalkingPointUpsertContext);
};

export default TalkingPointUpsertProvider;
